import { render, staticRenderFns } from "./newRotateCtrl.vue?vue&type=template&id=3e994a76&scoped=true&"
import script from "./newRotateCtrl.vue?vue&type=script&lang=js&"
export * from "./newRotateCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e994a76",
  null
  
)

export default component.exports